import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreAppsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-apps',
	path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
	exact: true,
};
